export default __webpack_public_path__ + "static/media/mockupwebapp3.e65a7c4f.jpg";